module.exports = __webpack_public_path__ + "img/25.59feb8df.jpg";